import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/mt_shop_finger.png'
import _imports_1 from '@/assets/mt_shop_arrow.png'


const _hoisted_1 = { class: "our_advantages" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "thumb_wrapper" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Thumbs Up",
    class: "thumbs_img",
    loading: "lazy",
    decoding: "async"
  })
], -1)
const _hoisted_5 = { class: "advantages_grid" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "Arrow down",
  class: "arrow_down",
  loading: "lazy",
  decoding: "async"
}, null, -1)
const _hoisted_7 = { class: "center_button_wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContactButton = _resolveComponent("ContactButton")!
  const _component_AdvantageItem = _resolveComponent("AdvantageItem")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("h1", null, _toDisplayString(_ctx.t('landingMTShop.advantages.title_part1')), 1),
          _createVNode(_component_ContactButton, { "content-name": "mt_shop_advantages_contact_top" })
        ]),
        _createElementVNode("h1", null, _toDisplayString(_ctx.t('landingMTShop.advantages.title_part2')), 1)
      ]),
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.advantagesList, (item, index) => {
          return (_openBlock(), _createBlock(_component_AdvantageItem, {
            key: index,
            number: item.number,
            title: item.title,
            description: item.description
          }, null, 8, ["number", "title", "description"]))
        }), 128))
      ]),
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_ContactButton, { "content-name": "mt_shop_advantages_contact_bottom" })
      ])
    ])
  ]))
}